import { isMatching, P } from 'ts-pattern';

export const isSortingState = isMatching(
  P.array({
    desc: P.boolean,
    id: P.string,
  }),
);
